import type { JSX } from "preact";

const MIRRORED_PROPERTIES = [
  "box-sizing",
  "width",
  "height",
  "overflow-x",
  "overflow-y",
  "border-top-width",
  "border-right-width",
  "border-bottom-width",
  "border-left-width",
  "padding-top",
  "padding-right",
  "padding-bottom",
  "padding-left",
  "font-style",
  "font-variant",
  "font-weight",
  "font-stretch",
  "font-size",
  "line-height",
  "font-family",
  "text-align",
  "text-transform",
  "text-indent",
  "letter-spacing",
  "word-spacing",
  "tab-size",
  "white-space",
  "word-break",
];

const buildMirror = (textarea: HTMLTextAreaElement, index: number): HTMLSpanElement => {
  const computed = window.getComputedStyle(textarea);
  const mirror = document.createElement("div");
  mirror.style.position = "absolute";
  mirror.style.visibility = "hidden";
  mirror.style.whiteSpace = "pre-wrap";
  mirror.style.wordWrap = "break-word";
  mirror.style.width = `${textarea.clientWidth}px`;
  for (const property of MIRRORED_PROPERTIES) {
    mirror.style.setProperty(property, computed.getPropertyValue(property));
  }
  mirror.textContent = textarea.value.slice(0, index);
  const marker = document.createElement("span");
  marker.textContent = textarea.value.slice(index) || ".";
  mirror.appendChild(marker);
  document.body.appendChild(mirror);
  return marker;
};

const caretPixelPosition = (textarea: HTMLTextAreaElement, index: number): { top: number; left: number; height: number } => {
  const marker = buildMirror(textarea, index);
  const mirror = marker.parentElement as HTMLDivElement;
  const position = { top: marker.offsetTop - textarea.scrollTop, left: marker.offsetLeft - textarea.scrollLeft, height: marker.offsetHeight };
  document.body.removeChild(mirror);
  return position;
};

const POPUP_WIDTH = 256;

export const mentionPopupStyle = (textarea: HTMLTextAreaElement, wrapper: HTMLElement, caretIndex: number): JSX.CSSProperties => {
  const caret = caretPixelPosition(textarea, caretIndex);
  const top = textarea.offsetTop + caret.top + caret.height + 4;
  const maxLeft = Math.max(4, wrapper.clientWidth - POPUP_WIDTH - 4);
  const left = Math.min(Math.max(4, textarea.offsetLeft + caret.left), maxLeft);
  return { top: `${top}px`, left: `${left}px` };
};
